export default __webpack_public_path__ + "93fcdb6d386dd24503699f1fa506ab17.svg";